import type {
  AccountDeletionRequestResponseDto,
  RequestAccountDeletionDto,
} from '@nomiss/sdk';
import { ResponseError } from '@nomiss/sdk';
import { ApiRequestError, parseApiErrorResponse } from './api-request.util';
import { accountDeletionRequestsApi } from './sdk-client';

export class AccountDeletionRequestError extends ApiRequestError {
  constructor(status: number, message: string) {
    super(status, message, 'AccountDeletionRequestError');
  }
}

export async function requestAccountDeletion(
  dto: RequestAccountDeletionDto,
): Promise<AccountDeletionRequestResponseDto> {
  try {
    return await accountDeletionRequestsApi.accountDeletionRequestsControllerRequestDeletionV1({
      requestAccountDeletionDto: dto,
    });
  } catch (error) {
    if (error instanceof ResponseError) {
      throw await parseApiErrorResponse(
        error.response,
        'Failed to submit account deletion request',
        AccountDeletionRequestError,
      );
    }
    throw error;
  }
}
